import { useCallback } from 'react';
import { NavigateOptions, useLocation, useNavigate } from 'react-router-dom';

// Give this state to each in-app navigation to a page that has a back arrow.
export const inAppNavigation = {
  state: { inApp: true },
} satisfies NavigateOptions;

const isInAppEntry = (state: unknown): boolean =>
  typeof state === 'object' &&
  state !== null &&
  'inApp' in state &&
  state.inApp === true;

export const useNavigateBack = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    // Without the marker, the previous history entry can be a login or redirect entry that opens this page again.
    if (isInAppEntry(location.state)) {
      navigate(-1);
    } else {
      navigate('..', { relative: 'route', replace: true });
    }
  }, [navigate, location.state]);
};
